import { Link, Typography } from '@material-ui/core'

interface Props {
  oldConsoleUrl: string
}

export function OldConsoleLink({ oldConsoleUrl }: Props) {
  return (
    <Typography variant="h6">
      <Link
        style={{ cursor: 'pointer' }}
        onClick={() => {
          window.open(oldConsoleUrl)
        }}
      >
        View in old console
      </Link>
    </Typography>
  )
}
